export default [
  {
    path: '/apps/empresa/list',
    name: 'apps-empresa-list',
    component: () => import('@/views/cadastros/info-organizacionais/empresa/list/Index.vue'),
    meta: {
      pageTitle: 'Empresa',
    },
  },
];
